import { Ref } from 'vue';
import { AppStore, AppStoreInterface } from '@/shared/infrastructure/store/AppStore';
import { usePlocState, getStore } from '@hfc/ui-core';

interface UseAppStoreInterface {
  appStore: AppStore;
  appState: Ref<AppStoreInterface>;
}

export const useAppStore = (): UseAppStoreInterface => {
  const appStore = getStore<AppStore>('AppStore', AppStore);
  const appState = usePlocState(appStore) as Ref<AppStoreInterface>;

  return {
    appStore,
    appState,
  };
};
